import { render, staticRenderFns } from "./FrontStaffPostModal.vue?vue&type=template&id=5ed30d3e&"
import script from "./FrontStaffPostModal.vue?vue&type=script&lang=ts&"
export * from "./FrontStaffPostModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports